import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput, Select } from '@origo/origo-ui';
import type { PlanInfoFormValues, SelectOption } from '../../../types';
import PageSection from '../../../components/PageSection';
import styles from './NameStatusSection.module.css';

interface NameStatusSectionProps {
    values: Pick<PlanInfoFormValues, 'plannavn' | 'plantype' | 'planstatus'>;
    plantypeOptions: SelectOption[];
    planstatusOptions: SelectOption[];
    onChange: (field: 'plannavn' | 'plantype' | 'planstatus', value: string) => void;
}

const NameStatusSection: React.FC<NameStatusSectionProps> = ({
    values,
    plantypeOptions,
    planstatusOptions,
    onChange,
}) => {
    const { t } = useTranslation();

    return (
        <PageSection title={t('planInfo.sections.nameStatus')} asFieldset>
            <TextInput
                label={t('planInfo.fields.plannavn')}
                placeholder={t('planInfo.fields.plannavnPlaceholder')}
                value={values.plannavn}
                onChange={e => onChange('plannavn', e.target.value)}
            />
            <div className={styles.twoColumn}>
                <Select
                    label={t('planInfo.fields.plantype')}
                    placeholder={t('planInfo.fields.plantypePlaceholder')}
                    value={values.plantype}
                    onChange={e => onChange('plantype', e.target.value)}
                    options={plantypeOptions}
                />
                <Select
                    label={t('planInfo.fields.planstatus')}
                    placeholder={t('planInfo.fields.planstatusPlaceholder')}
                    value={values.planstatus}
                    onChange={e => onChange('planstatus', e.target.value)}
                    options={planstatusOptions}
                />
            </div>
        </PageSection>
    );
};

export default NameStatusSection;
